import { render, staticRenderFns } from "./videoDetailsComponent.vue?vue&type=template&id=6d182798&scoped=true"
import script from "./videoDetailsComponent.vue?vue&type=script&lang=js"
export * from "./videoDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./videoDetailsComponent.vue?vue&type=style&index=0&id=6d182798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d182798",
  null
  
)

export default component.exports